import { useRouter } from 'next/router'

import { paths } from '@mc/paths'
import { useTranslation } from '@mc/i18n'
import { trackPurchaseClick } from '@mc/pre-paywall-events'
import { getPageSource } from '@mc/track-event'
import { usePrimaryCta } from '@mc/growth'

import { CONCIERGE_EXPERIENCE_I18N_NAMESPACE } from '../i18n/i18nInstance'
import { OptionPill } from './OptionPill'
import { useFab } from './FabProvider'

const useOptions = () => {
  const router = useRouter()
  const { toggleConcierge } = useFab()

  const goToPage = (page: string) => {
    router.push(page)
  }

  const scrollToFaq = () => {
    const faqElement = document.getElementById('faq')
    if (faqElement) {
      faqElement.scrollIntoView({ behavior: 'smooth', block: 'nearest' })
    }
    toggleConcierge(false)
  }

  return {
    goToPage,
    scrollToFaq,
  }
}

export const CommonOptions = () => {
  const { t } = useTranslation(CONCIERGE_EXPERIENCE_I18N_NAMESPACE)
  const { goToPage, scrollToFaq } = useOptions()
  const { changeView } = useFab()
  const { ctaHref } = usePrimaryCta()

  return (
    <>
      <OptionPill
        question={t('fab.options.variant_1.option1')}
        onClick={() => goToPage(ctaHref)}
      />
      <OptionPill
        question={t('fab.options.variant_1.option2')}
        onClick={() => goToPage(paths.categories)}
      />
      <OptionPill
        question={t('fab.options.variant_1.option3')}
        onClick={() => changeView('explainer')}
      />
      <OptionPill
        question={t('fab.options.variant_1.option4')}
        onClick={() => scrollToFaq()}
      />
    </>
  )
}

export const FabOptionsVariant1 = () => <CommonOptions />

export const FabOptionsVariant2 = () => {
  const { t } = useTranslation(CONCIERGE_EXPERIENCE_I18N_NAMESPACE)
  const { goToPage } = useOptions()

  const handleClick = () => {
    trackPurchaseClick({
      action: t('fab.options.variant_2.option5'),
      href: paths.gift,
      location: 'concierge',
      pageSource: getPageSource(),
    })
    goToPage(paths.gift)
  }

  return (
    <>
      <CommonOptions />
      <OptionPill
        question={t('fab.options.variant_2.option5')}
        onClick={handleClick}
      />
    </>
  )
}

export const FabOptionsVariant3 = () => {
  const { t } = useTranslation(CONCIERGE_EXPERIENCE_I18N_NAMESPACE)
  const { goToPage } = useOptions()

  const handleClick = () => {
    trackPurchaseClick({
      action: t('fab.options.variant_3.option5'),
      href: paths.checkout,
      location: 'concierge',
      pageSource: getPageSource(),
    })
    goToPage(paths.checkout)
  }

  return (
    <>
      <CommonOptions />
      <OptionPill
        question={t('fab.options.variant_3.option5')}
        onClick={handleClick}
      />
    </>
  )
}
